import { render } from "./Own.vue?vue&type=template&id=38d0502a"
import script from "./Own.vue?vue&type=script&lang=js"
export * from "./Own.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/Own.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d0502a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d0502a', __exports__)) {
    api.reload('38d0502a', __exports__)
  }
  
  module.hot.accept("./Own.vue?vue&type=template&id=38d0502a", () => {
    api.rerender('38d0502a', render)
  })

}


export default __exports__